
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/[digest]",
      function () {
        return require("private-next-pages/blog/[digest].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/[digest]"])
      });
    }
  